<template>
  <div>
    <template v-if="data">
    <div class="flex-right">
      <Button type="primary" @click="save">保存</Button>
    </div>
    <Card class="one-card">
      <h2 slot="title">意向国家</h2>
      <i-form :model="data" label-position="top">
        <Row :gutter="16">
          <i-col span="24">
            <FormItem label="Parents' Marital Status">
              <Select
                v-model="data.countries_of_interest"
                multiple
                style="width: 100%"
              >
                <Option
                  v-for="item in countries_of_interest_option"
                  :value="item"
                  :key="item"
                  >{{ item }}</Option
                >
              </Select>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">Most Recent Secondary School</h2>
      <i-form :model="data" label-position="top">
        <template v-for="(item, index) in data.most_recent_secondary_school">
          <Divider v-if="index > 0" :key="item.name + 'divider'" />
          <Row :gutter="16" :key="item.name">
            <i-col span="6">
              <FormItem label="Name">
                <i-input v-model="item.name"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Address">
                <i-input v-model="item.address"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Date of Entry">
                <DatePicker
                  type="date"
                  placeholder="Graduation Date"
                  style="width: 100%"
                  v-model="item.date_of_entry"
                ></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Graduation Date">
                <DatePicker
                  type="date"
                  placeholder="Graduation Date"
                  style="width: 100%"
                  v-model="item.graduation_date"
                ></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Course Type">
                <Select v-model="item.course_type" style="width: 100%">
                  <Option
                    v-for="item in course_type_option"
                    :value="item"
                    :key="item"
                    >{{ item }}</Option
                  >
                </Select>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="CEEB">
                <i-input v-model="item.CEEB"></i-input>
              </FormItem>
            </i-col>
          </Row>
        </template>

        <Row :gutter="16">
          <i-col span="24">
            <Button type="dashed" @click="add_one_recent_school"
              >添加一条</Button
            >
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last_recent_school"
              >删除最后一条</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">College & University</h2>
      <i-form :model="data" label-position="top">
        <template v-for="(item, index) in data.college">
          <Divider v-if="index > 0" :key="item.name + 'divider'" />
          <Row :gutter="16" :key="item.name">
            <i-col span="6">
              <FormItem label="Name">
                <i-input v-model="item.name"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Address">
                <i-input v-model="item.address"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Date of Entry">
                <DatePicker
                  type="date"
                  placeholder="Graduation Date"
                  style="width: 100%"
                  v-model="item.date_of_entry"
                ></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Graduation Date">
                <DatePicker
                  type="date"
                  placeholder="Graduation Date"
                  style="width: 100%"
                  v-model="item.graduation_date"
                ></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Major">
                <i-input v-model="item.major"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="CEEB">
                <i-input v-model="item.CEEB"></i-input>
              </FormItem>
            </i-col>
          </Row>
        </template>

        <Row :gutter="16">
          <i-col span="24">
            <Button type="dashed" @click="add_one_college">添加一条</Button>
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last_college"
              >删除最后一条</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">Counselor</h2>
      <i-form :model="data.counselor" label-position="top">
        <Row :gutter="16">
          <i-col span="6">
            <FormItem label="Name">
              <i-input v-model="data.counselor.name"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Title">
              <i-input v-model="data.counselor.title"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Email">
              <i-input v-model="data.counselor.email"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Mobile Phone">
              <i-input v-model="data.counselor.mobile_phone"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">Other School</h2>
      <i-form :model="data" label-position="top">
        <template v-for="(item, index) in data.other_school">
          <Divider v-if="index > 0" :key="item.name + 'divider'" />
          <Row :gutter="16" :key="item.name">
            <i-col span="6">
              <FormItem label="Name">
                <i-input v-model="item.name"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Address">
                <i-input v-model="item.address"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Date of Entry">
                <DatePicker
                  type="date"
                  placeholder="Graduation Date"
                  style="width: 100%"
                  v-model="item.date_of_entry"
                ></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Graduation Date">
                <DatePicker
                  type="date"
                  placeholder="Graduation Date"
                  style="width: 100%"
                  v-model="item.graduation_date"
                ></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="Course System">
                <i-input v-model="item.course_system"></i-input>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="CEEB">
                <i-input v-model="item.CEEB"></i-input>
              </FormItem>
            </i-col>
          </Row>
        </template>

        <Row :gutter="16">
          <i-col span="24">
            <Button type="dashed" @click="add_one_other_school"
              >添加一条</Button
            >
            <Button
              type="text"
              style="margin-left: 10px"
              @click="delelt_last_other_school"
              >删除最后一条</Button
            >
          </i-col>
        </Row>
      </i-form>
    </Card>

    <div class="flex-right">
      <Button type="primary" @click="save">保存</Button>
    </div>
    </template>
  </div>
</template>

<script>
import bus from '@/bus.js';
export default {
  data() {
    return {
      data: false,
      countries_of_interest_option: ["US", "UK", "CAN", "HK", "AUS", "Other"],
      course_type_option: ["IB", "ALEVEL", "AP"],
    };
  },
  methods: {
    async getData() {
      if (!this.$store.getters.selectedStudent._id) {
        return;
      }

      let res = await this.api({
        url: "/student/getEducationInfoById",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });

      this.data = res;
    },

    add_one_recent_school() {
      this.data.most_recent_secondary_school.push({
        name: "",
        sibship: "",
      });
    },

    delelt_last_recent_school() {
      this.data.most_recent_secondary_school.pop();
    },

    add_one_college() {
      this.data.college.push({
        name: "",
        sibship: "",
      });
    },

    delelt_last_college() {
      this.data.college.pop();
    },

    add_one_other_school() {
      this.data.other_school.push({
        name: "",
        sibship: "",
      });
    },

    delelt_last_other_school() {
      this.data.other_school.pop();
    },

    async save() {
      let most_recent_secondary_school = this.data.most_recent_secondary_school;
      most_recent_secondary_school = most_recent_secondary_school.map(
        (item) => {
          item.date_of_entry = this.$moment(item.date_of_entry).format(
            "YYYY-MM-DD"
          );
          item.graduation_date = this.$moment(item.graduation_date).format(
            "YYYY-MM-DD"
          );

          return item;
        }
      );

      let college = this.data.college;
      college = college.map((item) => {
        item.date_of_entry = this.$moment(item.date_of_entry).format(
          "YYYY-MM-DD"
        );
        item.graduation_date = this.$moment(item.graduation_date).format(
          "YYYY-MM-DD"
        );

        return item;
      });

      let other_school = this.data.other_school;
      other_school = other_school.map((item) => {
        item.date_of_entry = this.$moment(item.date_of_entry).format(
          "YYYY-MM-DD"
        );
        item.graduation_date = this.$moment(item.graduation_date).format(
          "YYYY-MM-DD"
        );

        return item;
      });

      await this.api({
        url: "/student/saveEducationInfo",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          student_id: this.$store.getters.selectedStudent._id,
          countries_of_interest: JSON.stringify(
            this.data.countries_of_interest
          ),
          most_recent_secondary_school: JSON.stringify(
            most_recent_secondary_school
          ),
          college: JSON.stringify(college),
          counselor: JSON.stringify(this.data.counselor),
          other_school: JSON.stringify(other_school),
        },
      });

      this.$Message.success("更新成功");
        bus.$emit("reloadStudentList");

    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    "$store.getters.selectedStudent": function () {
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bolder;
}
.one-card {
  margin-bottom: 20px;
}
</style>